DeepModel = require 'models/base/deep_model'

module.exports = class Client extends DeepModel
  urlRoot: '/api/pronto/patients'

  defaults: 
    gender: 'X'
